import React, { useEffect, useState } from "react";
import Page from "../../components/DefaultPage/DefaultPage";
import classes from "./UserList.module.css";
import { useTranslation } from "react-i18next";
import LoadingPage from "../LoadingPage/LoadingPage";
import Backdrop from "../../components/BackDrop/BackDrop";
import serverPostData from "../../utils/ServerPostData";
import { MdDelete } from "react-icons/md";
import { AddForm } from "../../components/Cards/Cards";

function AddAdminModal({ user, onCancel, onConfirm }) {
  return (
    <>
      <AddForm cancel={onCancel} confirm={onConfirm} />
      <Backdrop cancel={onCancel} />
    </>
  );
}

function UserList() {
  const [users, setUsers] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [searchTerm, setSearchTerm] = useState("");
  const [orderBy, setOrderBy] = useState("");
  const [selectedUser, setSelectedUser] = useState(null);
  const [modalOpen, setModalOpen] = useState(false);

  const { t } = useTranslation("global");

  const ip = process.env.REACT_APP_SERVER_IP;
  const port = process.env.REACT_APP_SERVER_PORT;
  const protocol = process.env.REACT_APP_SERVER_PROTOCOL;
  const serverPath = `${protocol}://${ip}:${port}/user-stats`;
  const serverPath2 = `${protocol}://${ip}:${port}/admin-stats`;

  useEffect(() => {
    const fetchData = async () => {
      try {
        const [userRes, adminRes] = await Promise.all([
          fetch(serverPath),
          fetch(serverPath2),
        ]);
  
        const usersData = await userRes.json();
        const adminsData = await adminRes.json();
  
        const adminEmails = new Set(Object.values(adminsData).map(admin => admin.email));
  
        const usersWithAdminFlag = Object.values(usersData).map(user => ({
          ...user,
          admin: adminEmails.has(user.email),
        }));
  
        setUsers(usersWithAdminFlag);
        setIsLoading(false);
      } catch (error) {
        console.error("Erro ao buscar dados:", error);
        setIsLoading(false);
      }
    };
  
    fetchData();
  }, []);
  

  function filterAndOrderUsers(users) {
    let filtered = users.filter((user) =>
      user.name?.toLowerCase().includes(searchTerm.toLowerCase()) ||
      user.email?.toLowerCase().includes(searchTerm.toLowerCase())
    );

    if (orderBy === "name") {
      filtered.sort((a, b) => (a.name || "").localeCompare(b.name || ""));
    } else if (orderBy === "email") {
      filtered.sort((a, b) => (a.email || "").localeCompare(b.email || ""));
    }

    return filtered;
  }

  function handleAddAdmin(user) {
    setSelectedUser(user);
    setModalOpen(true);
  }

  function handleCancel() {
    setModalOpen(false);
    setSelectedUser(null);
  }

  function handleConfirm() {
    const userId = selectedUser.id || selectedUser.email;
    const formData = new FormData();
    formData.append("id", userId);     // Certifique-se de que user.id exista
    formData.append("email", selectedUser.email);

    setModalOpen(false);
    setSelectedUser(null);

    serverPostData("/dashboard-add-admin", formData).then((response) => {
      if (response.status === 200) {
        alert(t("global.general.success"));
        window.location.reload();
      } else {
        alert(t("global.general.error"));
      }
    });
  }

  if (isLoading) {
    return (
      <section>
        <LoadingPage />
      </section>
    );
  }

  const displayedUsers = filterAndOrderUsers(users);

  return (
    <Page>
      <div className={classes.container}>
        <h1>Lista de Utilizadores</h1>

        <div className={classes.controls}>
          <input
            className={classes.searchbar}
            type="text"
            placeholder={t("sorter.searchBar.placeholder")}
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            style={{
              background: `url('data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="%23000000" width="24px" height="24px"><path d="M0 0h24v24H0z" fill="none"/><path d="M15.5 14h-.79l-.28-.27a6.5 6.5 0 0 0 1.48-5.34c-.47-2.78-2.79-5-5.59-5.34a6.505 6.505 0 0 0-7.27 7.27c.34 2.8 2.56 5.12 5.34 5.59a6.5 6.5 0 0 0 5.34-1.48l.27.28v.79l4.25 4.25c.41.41 1.08.41 1.49 0 .41-.41.41-1.08 0-1.49L15.5 14zm-6 0C7.01 14 5 11.99 5 9.5S7.01 5 9.5 5 14 7.01 14 9.5 11.99 14 9.5 14z"/></svg>') no-repeat 5px center`,
              paddingLeft: "30px",
              color: "rgba(0, 0, 0, 0.54)",
              fontSize: "16px",
              lineHeight: "1.5",
              border: "2px solid #067451",
              borderRadius: "4px",
              boxSizing: "border-box",
              width: "100%",
              height: "36px",
              outline: "none"
            }}
          />

          <select
            className={classes.select}
            value={orderBy}
            onChange={(e) => setOrderBy(e.target.value)}
          >
            <option value="" disabled hidden>
              {t("sorter.selectButtonLabels.sortBy")}
            </option>
            <option value="name">{t("stats.titles.Name")}</option>
            <option value="email">{t("stats.titles.Email")}</option>
          </select>
        </div>

        <table className={classes.table}>
          <thead>
            <tr>
              <th>Nome</th>
              <th>Email</th>
              <th>Administrador</th>
            </tr>
          </thead>
          <tbody>
            {displayedUsers.map((user, index) => (
              <tr key={index}>
                <td>{user.name || "Sem nome"}</td>
                <td>
                  {user.admin ? (
                    <button
                      className={classes.emailButton2}
                      disabled  // Torna o botão desabilitado
                    >
                      {user.email || "Sem email"}
                    </button>
                  ) : (
                    <button
                      className={classes.emailButton}
                      onClick={() => handleAddAdmin(user)}
                    >
                      {user.email || "Sem email"}
                    </button>
                  )}
                </td>


                <td>{user.admin ? "Sim" : "Não"}</td>
              </tr>
            ))}
          </tbody>
        </table>

        {modalOpen && (
          <AddAdminModal
            user={selectedUser}
            onCancel={handleCancel}
            onConfirm={handleConfirm}
          />
        )}
      </div>
    </Page>
  );
}

export default UserList;
